export const isOlderThan24Hours = (createdAt: Date | string | number): boolean => {
    const createdTime = new Date(createdAt).getTime()
    const currentTime = Date.now()
    const twentyFourHoursInMs = 24 * 60 * 60 * 1000
    return currentTime - createdTime > twentyFourHoursInMs
}